import React from 'react';
import { Navigate } from 'react-router-dom';

// Definindo os tipos para as props
interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const subdomain = window.location.hostname.split('.')[0];

  // if (subdomain !== 'gestao') {
  //   return <Navigate to="/acesso-negado" />;  
  // }

  return <>{element}</>; 
};

export default ProtectedRoute;
